import { useTranslation } from 'react-i18next'
import { connect, useDataItem } from 'scrivito'

import { ListContactTab } from './ListContactTab/ListContactTab'
import { NavTabs, NavTabItem } from '@/Atomic/Templates/NavTabs'
import { DataClassName, FeatureFlags } from '@/Data/const'
import { ContactListRelation } from '@/Data/ContactListRelation/ContactListRelationDataClass'
import { useFeatureFlags } from '@/hooks/useFeatureFlagHandler'

export const ListDataItemTabs: React.FC = connect(() => {
  const { t } = useTranslation()
  const { isEnabled } = useFeatureFlags()
  const dataItem = useDataItem()
  const dataItemId = dataItem?.id() ?? ''

  if (!dataItemId) return

  const showContact = isEnabled(FeatureFlags.SHOW_CONTACT)
  const contactEntity =
    dataItem?.get('entityType') === DataClassName.COMPANY
      ? DataClassName.COMPANY
      : DataClassName.PERSON

  const contactCount = showContact
    ? (ContactListRelation.all()
        .transform({ filters: { list: dataItemId, contactEntity } })
        .count() ?? 0)
    : 0

  const tabs: NavTabItem[] = showContact
    ? [
        {
          id: contactEntity === DataClassName.COMPANY ? 'companies' : 'persons',
          title:
            contactEntity === DataClassName.COMPANY
              ? t('pages.companies.title')
              : t('components.person.title'),
          icon:
            contactEntity === DataClassName.COMPANY
              ? 'building'
              : 'user-multiple',
          count: contactCount,
          content: <ListContactTab contactEntity={contactEntity} />,
        },
      ]
    : []

  return <NavTabs tabs={tabs} />
})
